import { connect, FormikValues } from 'formik'
import { IntlShape } from 'react-intl'
import { array, object, string } from 'yup'

import messages from '@/pages/SpaceAppBuilder/FeaturesPage/Operations/messages'
import { BooleanStepData, StepData } from '@/pages/SpaceAppBuilder/utilities/interfaces'

import Conditions from './Conditions'
import { BooleanOperationParams } from './Conditions/interfaces'
import { Operator } from './Conditions/utils'

// TODO Update the required error messages to merge them into a single error
const getValidationSchema = (intl: IntlShape) => {
  return {
    conditions: array().of(
      object().shape({
        filters: array().of(
          object().shape({
            leftComparator: string().trim().required(intl.formatMessage(messages.booleanOperatorErrorLeft)),
            rightComparator: string()
              .trim()
              .when('operator', {
                is: Operator.PR,
                then: string().notRequired(),
                otherwise: string().trim().required(intl.formatMessage(messages.booleanOperatorErrorRight))
              })
          })
        )
      })
    )
  }
}

const getInitialValues = (stepData: BooleanStepData): StepData => ({
  conditions: stepData.conditions ?? [
    {
      filters: [
        {
          leftComparator: '',
          operator: Operator.EQ,
          rightComparator: ''
        }
      ],
      expression: ''
    }
  ],
  onTrue: stepData.onTrue ?? [],
  onFalse: stepData.onFalse ?? []
})
const getBooleanOperationHelpUrl = 'https://help.workgrid.com/s/article/Boolean-Operation'
const BooleanOperation = ({
  variables,
  formik,
  readOnly = false
}: Omit<BooleanOperationParams, 'name'> & FormikValues) => {
  return (
    <Conditions
      name="stepData.conditions"
      conditions={formik.values.stepData?.conditions}
      readOnly={readOnly}
      variables={variables}
    />
  )
}

export default connect(BooleanOperation)

export { getValidationSchema, getInitialValues, getBooleanOperationHelpUrl }
